<template>
    <div class="no_premium_btn" :style="'width:'+width+'px'">
        <button class="ulozit">
            Uložiť
        </button>
    </div>
</template>

<script>
    export default {
        props: ['width']
    }
</script>

<style lang="scss" scoped>
    .no_premium_btn{
        margin: 0 auto 0 auto;
        .ulozit{
            background: #45D7B6;
            border-radius: 4px;
            width: 100%;
            height: 55px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 15px;
            text-align: center;
            color: #FFFFFF;
            cursor: pointer;
        }
    }
</style>